import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ROOT_URL } from '../../api/ApiConfig';

export const assignedAgent = createAsyncThunk('chat-room/assigned-agent-detail', async ({ id }, { getState, rejectWithValue }) => {
  const { loginToken } = getState();
  const authToken = loginToken?.response?.token;
  try {
    const response = await fetch(
      `${ROOT_URL}/chat-room/assigned-agent-detail/${id}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      },
    );
    const result = await response.json();
    return result;
  } catch (error) {
    return rejectWithValue(error.response);
  }
});

const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  isCompleted: false,
  response: [],
  error: null,
};

const AssignedAgent = createSlice(
  {
    name: 'AssignedAgent',
    initialState,
    reducers: {},
    extraReducers: {
      [assignedAgent.pending]: (state) => {
        state.isLoading = true;
      },
      [assignedAgent.fulfilled]: (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.response = action.payload;
      },
      [assignedAgent.rejected]: (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.error = action.payload;
      },
    },
  },
);

export default AssignedAgent;
